import React, { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useCurrentUser } from '@klp/auth';
import {
    useGetUserClientsQuery,
    useSelectClientMutation,
} from '@klp/client/components/Select/rtkApi';
import type { Client } from '@klp/common';

import { appSelectors } from '../store';
import { useAppParams } from '../useAppParams';

const ClientContext = createContext<Client | undefined>(undefined);

const ClientProvider: React.FC = ({ children }) => {
    const [state, setState] = useState<Client | undefined>(undefined);

    const appParams = useAppParams();
    const { trigger } = useSelector(appSelectors);
    const { currentUser, isAuthenticated } = useCurrentUser();

    const { data: clientsList } = useGetUserClientsQuery(
        {
            includeInActive: true,
        },
        {
            skip: !isAuthenticated || !currentUser,
        },
    );
    const [selectClient] = useSelectClientMutation();

    // Auto-select if only one client
    useEffect(() => {
        if (clientsList && clientsList.length === 1) {
            selectClient(clientsList[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientsList]);

    useEffect(() => {
        setState(appParams.selectedClient);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger]);

    return (
        <ClientContext.Provider value={state}>
            {children}
        </ClientContext.Provider>
    );
};

export default ClientProvider;
